import { EVENTS } from "../js/constants";

export default class Clicks {
  /**
   * Creates a tracking instance that handles clicks on links, teaser, cta, ...
   */
  constructor() {
    this.config = {
      selectors: {
        buttonsButton:
          ".Tracking--buttons:not(.Tracking--overlayTeaserButtons) .FskButton:not(.FskButton--donation)",
        buttonsLink:
          ".Tracking--buttons:not(.Tracking--overlayTeaserButtons) .Link",
        highlightButton: ".Tracking--highlight-button",
        overlayTeaser: ".Tracking--overlayTeaser",
        overlayOpen: ".Tracking--overlayTeaserOpenButton",
        overlayButtons:
          ".Tracking--overlayTeaserButtons .FskButton:not(.FskButton--donation)",
        overlayLinks: ".Tracking--overlayTeaserButtons .Link",
        rteLinks: ".Tracking--rte a",
        stageButtons: ".Tracking--stageButton",
        tagLinks: ".Tracking--tagsLink",
        teaserLinks: ".Tracking--teaserLink",
      },
    };

    this._init();
    this._asyncInit();
  }

  /**
   * inits for elements that are already mounted
   *
   * @private
   */
  _init() {
    const clickElements = [
      ...Clicks._getConfig(this.config.selectors.rteLinks, "link"),
      ...Clicks._getConfig(this.config.selectors.tagLinks, "tag"),
      ...Clicks._getConfig(this.config.selectors.teaserLinks, "teaser"),
      ...Clicks._getConfig(this.config.selectors.stageButtons, "cta"),
      ...Clicks._getConfig(this.config.selectors.buttonsButton, "cta"),
      ...Clicks._getConfig(this.config.selectors.buttonsLink, "cta"),
      ...Clicks._getConfig(
        this.config.selectors.highlightButton,
        "highlight_cta"
      ),
    ];

    Clicks._bind(clickElements);
  }

  /**
   * inits for elements that are loaded asynchronously
   * e.g. overlay teaser
   *
   * @private
   */
  _asyncInit() {
    const overlayTeaser = document.querySelector(
      this.config.selectors.overlayTeaser
    );

    if (overlayTeaser) {
      overlayTeaser.addEventListener(EVENTS.OVERLAY_INIT, () => {
        const clickElements = [
          ...Clicks._getConfig(
            this.config.selectors.overlayOpen,
            "overlay",
            "/"
          ),
          ...Clicks._getConfig(this.config.selectors.overlayLinks, "overlay"),
          ...Clicks._getConfig(this.config.selectors.overlayButtons, "overlay"),
        ];

        Clicks._bind(clickElements);
      });
    }
  }

  /**
   * looks for all elements with a specific selector
   * and returns a transformed object with tracking information
   *
   * @param {string} selector
   * @param {string} type
   * @param {string} href
   * @returns {Array} elements
   * @private
   * @static
   */
  static _getConfig(selector, type, href) {
    return [...document.querySelectorAll(selector)].map((el) => {
      return { el, type, href };
    });
  }

  /**
   * binds user events
   *
   * @param {Array} clickElements
   * @private
   */
  static _bind(clickElements) {
    clickElements.forEach((element) => {
      element.el.addEventListener("click", (event) => {
        const link = event.target.closest("a");
        Clicks._trackClick(
          element.href ? element.href : link.href,
          element.type
        );
      });
    });
  }

  /**
   * pushes click events to dataLayer
   *
   * @param {string} href
   * @param {string} type
   * @private
   * @static
   */
  static _trackClick(href, type) {
    const data = {
      event: "Event",
      event_name: `click_on_${type}`,
    };

    data[`click_on_${type}`] = {
      navigation_path: href,
      pp_event_category: "click",
      pp_event_action: type,
      pp_event_name: href,
    };

    window.dataLayer.push(data);
  }
}
